import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EquipmentTypeService } from '@app/api/equipmentType.service';
import { EquipmentCategoryService } from '@app/api/equipmentCategory.service';
import { BrandService } from '@app/api/api';
@Component({
  selector: 'meu-modal-equipment-type',
  templateUrl: './modal-equipment-type.component.html',
  styleUrls: ['./modal-equipment-type.component.scss'],
})
export class ModalEquipmentTypeComponent implements OnInit {
  isEdit: boolean = false;
  hasFormErrors: boolean = false;
  lstEquipmentCategories: any[] = [];
  lstBrands: any[] = [];
  selectedBrandIds: string[] = [];
  originalBrands: any[] = [];
  preselectedCategory: any = null;
  brandPage: number = 1;
  brandPageSize: number = 50;
  brandTotal: number = 0;
  brandLoading: boolean = false;
  saving: boolean = false;
  typeForm = new FormGroup({
    category_id: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    name_en: new FormControl(''),
    description: new FormControl(''),
  });
  constructor(
    public dialogRef: MatDialogRef<ModalEquipmentTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string | number | null, preselectedCategory?: any },
    private equipmentTypeService: EquipmentTypeService,
    private equipmentCategoryService: EquipmentCategoryService,
    private brandService: BrandService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}
  
  ngOnInit() {
    this.loadCategories();
    this.loadBrands();
    if (this.data.preselectedCategory) {
      this.preselectedCategory = this.data.preselectedCategory;
      this.typeForm.get('category_id').setValue(this.preselectedCategory.name || '');
      this.typeForm.get('category_id').disable();
    }
    if (this.data.id != null) {
      this.isEdit = true;
      this.getById(this.data.id);
    }
  }
  loadCategories() {
    this.equipmentCategoryService.apiEquipmentCategoriesGet('', '', 1, 1000).subscribe((res) => {
      if (res.success) {
        this.lstEquipmentCategories = res.data.collection;
        this.changeDetectorRef.detectChanges();
      }
    });
  }
  loadBrands() {
    if (this.brandLoading) return;
    var self = this;
    this.brandLoading = true;
    this.brandService.apiBrandsGet('', '', this.brandPage, this.brandPageSize).subscribe((res) => {
      this.brandLoading = false;
      if (res.success) {
        this.lstBrands = this.lstBrands.concat(res.data.collection);
        this.brandTotal = res.data.total;
        this.changeDetectorRef.detectChanges();
      }
    }, function() {
      self.brandLoading = false;
    });
  }

  onBrandScroll(event: any) {
    var target = event.target;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 5) {
      if (!this.brandLoading && this.lstBrands.length < this.brandTotal) {
        this.brandPage++;
        this.loadBrands();
      }
    }
  }
  toggleBrand(brandId: string) {
    const index = this.selectedBrandIds.indexOf(brandId);
    if (index > -1) {
      this.selectedBrandIds = this.selectedBrandIds.filter(function(id) { return id !== brandId; });
    } else {
      this.selectedBrandIds = this.selectedBrandIds.concat([brandId]);
    }
    this.changeDetectorRef.detectChanges();
  }
  isBrandSelected(brandId: string): boolean {
    return this.selectedBrandIds.indexOf(brandId) > -1;
  }
  getById(id: string | number) {
    this.equipmentTypeService.apiEquipmentTypesIdGet(String(id)).subscribe((res) => {
      if (res.success) {
        const categoryId = res.data.category_id;
        this.typeForm.patchValue({
          category_id: categoryId,
          name: res.data.name,
          name_en: res.data.name_en,
          description: res.data.description,
        });
        if (res.data.brands && Array.isArray(res.data.brands)) {
          var etbMap: { [key: string]: string } = {};
          if (res.data.equipment_type_brands && Array.isArray(res.data.equipment_type_brands)) {
            res.data.equipment_type_brands.forEach(function(etb: any) {
              if (etb.brand_id && etb.id) {
                etbMap[etb.brand_id] = etb.id;
              }
            });
          }
          this.originalBrands = res.data.brands.map(function(b: any) {
            return {
              brand_id: b.id,
              mapping_id: etbMap[b.id] || null,
              name: b.name
            };
          });
          this.selectedBrandIds = res.data.brands.map(function(b: any) { return b.id; });
        } else {
          this.originalBrands = [];
          this.selectedBrandIds = [];
        }
        if (categoryId) {
          this.equipmentCategoryService.apiEquipmentCategoriesIdGet(String(categoryId)).subscribe((catRes) => {
            if (catRes.success) {
              this.typeForm.get('category_id').setValue(catRes.data.name || '');
              this.changeDetectorRef.detectChanges();
            }
          });
        }
        this.changeDetectorRef.detectChanges();
      }
    });
  }
  save() {
    if (this.saving) return;
    this.saving = true;
    this.hasFormErrors = true;
    const controls = this.typeForm.controls;
    if (this.typeForm.invalid) {
      this.saving = false;
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    const categoryName = this.typeForm.get('category_id').value;
    var self = this;
    this.findOrCreateCategory(categoryName, (categoryId) => {
      this.typeForm.get('category_id').setValue(categoryId);
      const payload = this.typeForm.getRawValue();
      if (!this.isEdit) {
        if (this.selectedBrandIds.length > 0) {
          payload['brand_ids'] = this.selectedBrandIds.slice();
        }
        this.equipmentTypeService.apiEquipmentTypesPost(payload).subscribe((res) => {
          if (res.success) {
            this.dialogRef.close({ event: true, type: 'create' });
          } else {
            this.saving = false;
            this.dialogRef.close({ event: false, message: res.message });
          }
        }, function() {
          self.saving = false;
        });
      } else {
        this.saveEdit(payload);
      }
    });
  }
  findOrCreateCategory(name: string, callback: (categoryId: string) => void) {
    const existing = this.lstEquipmentCategories.find(
      (c) => c.name && c.name.trim().toLowerCase() === name.trim().toLowerCase()
    );
    if (existing) {
      callback(String(existing.id));
      return;
    }
    const code = this.generateCategoryCode(name);
    this.equipmentCategoryService
      .apiEquipmentCategoriesPost({ name: name.trim(), code: code, name_en: '', description: '' })
      .subscribe((res) => {
        if (res.success && res.data && res.data.id) {
          callback(String(res.data.id));
        } else {
          this.dialogRef.close({ event: false, message: res.message || 'Tạo chủng thiết bị thất bại' });
        }
      });
  }
  generateCategoryCode(name: string): string {
    return name
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '_')
      .replace(/[^A-Z0-9_]/g, '');
  }
  saveEdit(payload: any) {
    var self = this;
    var typeId = String(this.data.id);

    var originalBrandIds = this.originalBrands.map(function(ob) { return ob.brand_id; });
    var removedBrands = this.originalBrands.filter(function(ob) {
      return self.selectedBrandIds.indexOf(ob.brand_id) === -1;
    });
    var addedBrandIds = this.selectedBrandIds.filter(function(bid) {
      return originalBrandIds.indexOf(bid) === -1;
    });

    self.equipmentTypeService.apiEquipmentTypesIdPut(typeId, payload).toPromise().then(function() {
      var brandPromises: Promise<any>[] = [];

      removedBrands.filter(function(rb) { return rb.mapping_id; }).forEach(function(rb) {
        brandPromises.push(self.equipmentTypeService.apiEquipmentTypeBrandsIdDelete(rb.mapping_id).toPromise());
      });

      if (addedBrandIds.length > 0) {
        var addBody = addedBrandIds.map(function(bid) {
          return { equipment_type_id: typeId, brand_id: bid };
        });
        brandPromises.push(self.equipmentTypeService.apiEquipmentTypeBrandsPost(addBody).toPromise());
      }

      if (brandPromises.length > 0) {
        Promise.all(brandPromises).then(function() {
          self.dialogRef.close({ event: true, type: 'edit' });
        }).catch(function() {
          self.dialogRef.close({ event: true, type: 'edit' });
        });
      } else {
        self.dialogRef.close({ event: true, type: 'edit' });
      }
    }).catch(function() {
      self.saving = false;
      self.dialogRef.close({ event: false, message: 'Có lỗi xảy ra khi lưu' });
    });
  }

  closeModal() {
    this.dialogRef.close();
  }
}
